let ToastService = ($mdToast) => {
  function show(textContent, options) {
    let position = _.get(options, 'position') || 'bottom right';
    let theme = _.get(options, 'theme') || 'default';

    $mdToast.show(
        $mdToast.simple()
            .position(position)
            .textContent(textContent)
            .theme(theme)
    );
  }

  function error(textContent) {
    show(textContent, {
        theme: 'error-toast'
    });
  }

  function success(textContent) {
    show(textContent, {
        theme: 'success-toast'
    });
  }

  return { error, show, success };
};

ToastService.$inject = ['$mdToast'];

export default ToastService;



// WEBPACK FOOTER //
// ./client/app/common/services/toast.service.js